import * as React from 'react';
import { MouseEventHandler } from 'react';
import { getTrackedLink } from '../../utils/sourceTracking';

interface HeaderProps {
	sidebarHandler: MouseEventHandler;
	menuItems: Array<{ text: string; href: string; active: boolean }>;
}

// @ts-ignore
import logo from './belle-tire-logo.svg';

const Header: React.FC<HeaderProps> = (props: HeaderProps) => {
	return (
		<header className={'shadow'}>
			<div
				className={
					'container mx-auto flex flex-row justify-between px-3 py-[12.5px]'
				}
			>
				<a href={getTrackedLink('/')}>
					<img
						src={logo}
						width={180}
						className={'max-sm:max-h-[50px]'}
					/>
				</a>
				<div
					className={'header-container flex flex-col justify-center'}
				>
					<ul className={'hidden flex-row lg:flex '}>
						{props.menuItems.map((item) => {
							return (
								<li
									className={
										'px-5 font-rubik text-[16px] font-bold text-bt-blue hover:text-bt-red'
									}
								>
									<a
										className={'hover:text-bt-red'}
										href={getTrackedLink(item.href)}
									>
										{item.text}
									</a>
								</li>
							);
						})}
					</ul>
					<div className={'mobile group mr-4 flex lg:hidden'}>
						<button onClick={props.sidebarHandler}>
							<div
								className={
									'h-1 w-7 rounded bg-bt-blue group-hover:bg-bt-red'
								}
							/>
							<div
								className={
									'my-1 h-1 w-7 rounded bg-bt-blue group-hover:bg-bt-red'
								}
							/>
							<div
								className={
									'h-1 w-7 rounded bg-bt-blue group-hover:bg-bt-red'
								}
							/>
						</button>
					</div>
				</div>
			</div>
		</header>
	);
};

export default Header;
